import React from 'react';
import './AiInfoBar.css';

function formatRunningTime(startedAt) {
  if (!startedAt) return '-';
  const diff = Date.now() - new Date(startedAt).getTime();
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  if (days >= 1) return `${days}d ago`;
  const hours = Math.floor(diff / (1000 * 60 * 60));
  if (hours >= 1) return `${hours}h ago`;
  const mins = Math.floor(diff / (1000 * 60));
  return `${mins}m ago`;
}

function AiInfoBar({ challenge }) {
  const balance = challenge ? (challenge.trueBalance ?? challenge.currentBalance) : 0;
  const pnl = challenge ? (challenge.totalPnl || 0) : 0;
  const pnlPercent = challenge && challenge.startBalance
    ? ((balance - challenge.startBalance) / challenge.startBalance * 100)
    : 0;
  const winRate = challenge && challenge.totalTrades > 0
    ? ((challenge.winningTrades / challenge.totalTrades) * 100)
    : 0;
  const runningTime = challenge ? formatRunningTime(challenge.startedAt) : '-';

  const pnlClass = pnl >= 0 ? 'positive' : 'negative';

  return (
    <div className="ai-info-bar" data-tour="ai-info-bar">
      {/* Bot Identity */}
      <div className="ai-info-identity">
        <img
          src="/assets_new/img/deepseek-logo.svg"
          alt="DeepSeek"
          className="ai-info-avatar"
        />
        <div className="ai-info-name-block">
          <div className="ai-info-name">DeepSeek 4.5</div>
          <div className="ai-info-badge">
            Backed By{' '}
            <a href="https://tradermap.io" target="_blank" rel="noopener noreferrer" className="ai-info-badge-link">
              Tradermap
            </a>
          </div>
        </div>
      </div>

      <div className="ai-info-divider" />

      {/* Stats */}
      <div className="ai-info-stats">
        {/* Balance */}
        <div className="ai-info-stat">
          <div className="ai-info-stat-icon balance">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <line x1="12" y1="1" x2="12" y2="23" />
              <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6" />
            </svg>
          </div>
          <div className="ai-info-stat-text">
            <span className="ai-info-stat-label">Balance</span>
            <span className="ai-info-stat-value">
              ${balance.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
            </span>
          </div>
        </div>

        <div className="ai-info-divider" />

        {/* Total PnL */}
        <div className="ai-info-stat">
          <div className={`ai-info-stat-icon pnl ${pnlClass}`}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              {pnl >= 0 ? (
                <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" />
              ) : (
                <polyline points="23 18 13.5 8.5 8.5 13.5 1 6" />
              )}
            </svg>
          </div>
          <div className="ai-info-stat-text">
            <span className="ai-info-stat-label">Total PnL</span>
            <span className={`ai-info-stat-value ${pnlClass}`}>
              {pnl >= 0 ? '+' : ''}{pnl.toFixed(2)} ({pnlPercent >= 0 ? '+' : ''}{pnlPercent.toFixed(2)}%)
            </span>
          </div>
        </div>

        <div className="ai-info-divider" />

        {/* Win Rate */}
        <div className="ai-info-stat">
          <div className="ai-info-stat-icon winrate">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2" />
            </svg>
          </div>
          <div className="ai-info-stat-text">
            <span className="ai-info-stat-label">Win Rate</span>
            <span className="ai-info-stat-value">{winRate.toFixed(1)}%</span>
          </div>
        </div>

        <div className="ai-info-divider" />

        {/* Running Time */}
        <div className="ai-info-stat">
          <div className="ai-info-stat-icon running">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10" />
              <polyline points="12 6 12 12 16 14" />
            </svg>
          </div>
          <div className="ai-info-stat-text">
            <span className="ai-info-stat-label">Running</span>
            <span className="ai-info-stat-value">{runningTime}</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AiInfoBar;
